<template>
  <v-container fluid>
    <v-col class="col">
      <v-slide-y-transition mode="out-in">
        <v-row class="child-flex">
          <v-card>
            <v-card-text>
              <v-card-title>
                <h1 class="text-h4 mr-2">DMS Datasources</h1>
                <v-icon @click="refreshList">mdi-refresh</v-icon>
                <v-spacer></v-spacer>
                <v-switch
                  v-model="showTemplatesOnly"
                  :label="showTemplatesOnly ? 'Hide Templates': 'Show Templates'"
                  color="indigo"
                />
                <v-spacer></v-spacer>
                <v-text-field
                  @keydown.native.escape="search=''"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                  v-model="search"
                ></v-text-field>
              </v-card-title>
            </v-card-text>
            <v-data-table
              :headers="tableColumns"
              :items="queriedData"
              item-key="id"
              class="elevation-1"
            >
            <template v-slot:item.actions="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                   <v-btn v-bind="attrs" v-on="on" color="primary" dark small>
                     Actions
                   </v-btn>
                </template>
                 <v-list>
                   <v-list-item
                     v-for="(rowAction, index) in actions"
                     :key="index"
                     @click="executeAction(rowAction.action, item)"
                   >
                     <v-list-item-title>{{ rowAction.title }}</v-list-item-title>
                   </v-list-item>
                 </v-list>
              </v-menu>
            </template>

            </v-data-table>
          </v-card>
        </v-row>
      </v-slide-y-transition>
    </v-col>
    <v-btn fab bottom right color="pink" dark fixed :to="{'name': 'new_dms_datasource_path'}">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-container>
</template>
<script>

import { mapState } from 'vuex'
const R = require('ramda')

export default {
  components: {},
  computed: {
    ...mapState('ApplicationStore', ['dealerScopedView']),
    ...mapState('DatasourceStore', { tableData: 'datasources' }),
    ...mapState('DealerStore', ['dealer']),
    queriedData () {
      if (!this.search) {
        return this.tableData
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false
        for (let key of this.propsToSearch) {
          let rowValue = R.pathOr('', key.split('.'), row).toString()
          if (
            rowValue.includes &&
            rowValue.toLowerCase().includes(this.search.toLowerCase())
          ) {
            isIncluded = true
          }
        }
        return isIncluded
      })
      return result
    }
  },
  data: function () {
    return {
      search: '',
      showTemplatesOnly: false,
      propsToSearch: ['name', 'dealer.name'],
      tableColumns: [
        { text: 'Name', value: 'name' },
        { text: 'Dealer', value: 'dealer.name' },
        { text: 'Actions', value: 'actions' }
      ],
      actions: [
        { title: 'Edit', action: 'handleEdit' },
        { title: 'Delete', action: 'handleDelete' }
      ]
    }
  },
  mounted: function () {
    return this.refreshList()
  },
  watch: {
    dealer: function (newDealer, oldDealer) {
      this.refreshList()
    },
    showTemplatesOnly: function (newVal, oldVal) {
      this.refreshList()
    }
  },
  methods: {
    refreshList () {
      const fetchAction = this.showTemplatesOnly ? 'DatasourceStore/fetchDmsDatasourceTemplates' : 'DatasourceStore/fetchDmsDatasources'
      const queryParams = this.dealerScopedView ? { dealer_id: this.dealer.id } : {}
      this.$logger.trace('QUERY PARAMS FOR DMS DS', queryParams)
      return this.$store
        .dispatch(fetchAction, queryParams)
        .catch(error => {
          this.$flash({
            showClose: true,
            message: 'Error Loading Datasources. Reload to try again. ' + error.message,
            type: 'error'
          })
        })
    },
    handleDelete (row) {
      const shouldDelete = confirm('Are you sure you want to delete? This action can not be undone.')
      if (shouldDelete) {
        this.$store.dispatch('DatasourceStore/deleteDatasource', row)
          .then(() => {
            this.refreshList()
            this.$flash({
              showClose: true,
              message: 'Deleted Datasource',
              type: 'mini',
              duration: 2000
            })
          })
          .catch(error => {
            this.$flash({
              showClose: true,
              message: 'Error Deleting Datasource. ' + error.message,
              type: 'error',
              duration: 0
            })
          })
      }
    },
    handleEdit (item) {
      const path = item.type === 'DmsDatasourceTemplate' ? 'edit_dms_datasource_template_path' : 'edit_dms_datasource_path'
      this.$router.push({
        name: path,
        params: { id: item.id }
      })
    },
    executeAction (action, item) {
      this[action](item)
    },
    datasourceActions (item) {
      return this.actions[item.status]
    }
  }
}
</script>
